import { render, staticRenderFns } from "./AdditionalAttachmentsStep.vue?vue&type=template&id=d57a5d44&scoped=true&"
import script from "./AdditionalAttachmentsStep.vue?vue&type=script&lang=js&"
export * from "./AdditionalAttachmentsStep.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalAttachmentsStep.vue?vue&type=style&index=0&id=d57a5d44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d57a5d44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d57a5d44')) {
      api.createRecord('d57a5d44', component.options)
    } else {
      api.reload('d57a5d44', component.options)
    }
    module.hot.accept("./AdditionalAttachmentsStep.vue?vue&type=template&id=d57a5d44&scoped=true&", function () {
      api.rerender('d57a5d44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/portal-cebas/credentialing/steps/AdditionalAttachmentsStep.vue"
export default component.exports